import { useTranslation } from "react-i18next";
import { ReservationInfoCard } from "shared/components/organisms/ReservationDetails/components/ReservationInfoCard";
import { format } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import { getMultilingualString } from "shared/utils";
import { useNextBooking, UseNextBookingProps } from "./useNextBooking";

export const NextBooking = ({ person }: UseNextBookingProps) => {
  const { t } = useTranslation("people", {
    keyPrefix: "PERSON_DETAILS_MODAL.STOREFRONT_INFO.NEXT_BOOKING",
  });
  const { nextOrder } = useNextBooking({ person });

  if (!nextOrder) {
    return null;
  }

  const start = format(
    toZonedTime(
      nextOrder.purchasedProducts?.[0]?.inventoryClaims?.[0]
        ?.claimedDateRangeISO?.start ?? "",
      "UTC",
    ),
    "MMMM d, yyyy",
  );
  const end = format(
    toZonedTime(
      nextOrder.purchasedProducts?.[0]?.inventoryClaims?.[0]
        ?.claimedDateRangeISO?.end ?? "",
      "UTC",
    ),
    "MMMM d, yyyy",
  );
  const accommodationName = getMultilingualString(
    nextOrder.purchasedProducts?.[0]?.product?.name ?? {},
  );

  return (
    <ReservationInfoCard
      visual="success"
      title={t("TITLE")}
      description={t("DESCRIPTION", {
        orderId: nextOrder._id,
        start,
        end,
        accommodationName,
      })}
    />
  );
};
